import _ from 'lodash'

const DEFAULT_COLUMNS = [
  { key: 'Kundenr', default: '', name: 'Kundenr', sortKey: 'Kundenr', class: 'sorttable_numeric', readonly: true, selected: true },

  { key: 'Fnavn', default: '-', name: 'Fornavn', sortKey: 'Fnavn.sort', class: 'nowrap', selected: true },
  { key: 'Enavn', default: '-', name: 'Etternavn', sortKey: 'Enavn.sort', class: 'nowrap', selected: true },
  { key: 'Bedrift', default: '', name: 'Bedrift', sortKey: 'Bedrift', class: '', filter: 'bool', selected: true },
  { key: 'FirmaNavn', default: '-', name: 'Firmanavn', sortKey: 'FirmaNavn.sort', class: 'nowrap', selected: true },
  { key: 'Email', default: '-', name: 'Email', sortKey: 'Email', class: 'nowrap', selected: true },

  { key: 'Tlfprivat', default: '-', name: 'Tlfprivat', sortKey: 'Tlfprivat', class: '', selected: true },
  { key: 'Tlfarbeid', default: '-', name: 'Tlfarbeid', sortKey: 'Tlfarbeid', class: '', selected: true },
  { key: 'Mobil', default: '', name: 'Mobil', sortKey: 'Mobil', class: '', selected: true },

  { key: 'full_address_fak', default: '-', name: 'Fakt. adresse', sortKey: 'full_address_fak.raw', class: 'nowrap', tooltip: true, selected: true },
  { key: 'full_address_lev', default: '-', name: 'Lev. adresse', sortKey: 'full_address_lev.raw', class: 'nowrap', tooltip: true, selected: true },

  { key: 'Landkode', default: '-', name: 'Landkode', sortKey: 'Landkode', class: '', selected: true },

  { key: 'Sperret', default: '-', name: 'Sperret', sortKey: 'Sperret', class: '', filter: 'bool', selected: true },
  { key: 'Registrert_dato', default: '-', name: 'Reg. dato', sortKey: 'Registrert_dato', class: '', filter: 'date', selected: true },
  { key: 'Sist_endret_tid', default: '-', name: 'Endret dato', sortKey: 'Sist_endret_tid', class: '', filter: 'date', selected: true }
]

const DEFAULT_FILTERS = {
  kategori: [],
  auksjon: [],
  kunstner: null,
  objekttype: null,
  auksjonSearchAll: 0,
  avdeling: [],
  regdato: {},
  price: {}
}

const LS_KEY = 'customer-search-values'
const LS_KEY_COLS = 'columns'
const LS_KEY_QUERY = 'query'
const LS_KEY_FILTERS = 'filters'

const state = {
  defaultColumns: null,
  defaultFilters: null,
  defaultQuery: null
}

const loadLs = (key = null) => {
  try {
    const retval = JSON.parse(localStorage.getItem(LS_KEY) || {})

    if (key === null) {
      return retval
    }

    if (!retval.hasOwnProperty(key)) {
      return null
    }

    if (key === LS_KEY_FILTERS) {
      if (retval[key].regdato.from) {
        retval[key].regdato.from = new Date(retval[key].regdato.from)
      }

      if (retval[key].regdato.to) {
        retval[key].regdato.to = new Date(retval[key].regdato.to)
      }
    }

    return retval[key]
  } catch (e) {
    return null
  }
}

const saveLs = (key, data) => {
  try {
    const stored = loadLs() || {}
    stored[key] = data
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {
    // Ignore
  }
}

const getters = {
  query: state => {
    if (state.defaultQuery === null) {
      let query = loadLs(LS_KEY_QUERY) || ''

      return query
    }

    return state.defaultQuery
  },
  filters: state => {
    if (!state.defaultFilters) {
      let filters = loadLs(LS_KEY_FILTERS) || DEFAULT_FILTERS

      return filters
    }

    return state.defaultFilters
  },
  filterCount: (state, getters) => {
    let count = 0

    Object.keys(getters.filters).forEach(key => {
      const element = getters.filters[key]

      if (key === 'regdato') {
        if (element.from || element.to) {
          ++count
        }
      } else if (!_.isEmpty(element)) {
        ++count
      }
    })

    return count
  },
  columns: state => {
    if (!state.defaultColumns) {
      return loadLs(LS_KEY_COLS) || DEFAULT_COLUMNS
    }

    return state.defaultColumns
  }
}

const actions = {
  saveColumns: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveColumns', payload)
      resolve()
    })
  },
  resetColumns: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('resetColumns')
      resolve()
    })
  },
  saveQuery: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveQuery', payload)
      resolve()
    })
  },
  saveSearch: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveSearch', payload)
      resolve()
    })
  },
  resetSearch: ({commit, dispatch}, all) => {
    return new Promise((resolve, reject) => {
      commit('resetSearch', all)
      resolve()
    })
  }
}

const mutations = {
  'saveColumns': (state, payload) => {
    state.defaultColumns = payload
    saveLs(LS_KEY_COLS, payload)
  },
  'resetColumns': (state) => {
    state.defaultColumns = DEFAULT_COLUMNS
    saveLs(LS_KEY_COLS, DEFAULT_COLUMNS)
  },
  'saveQuery': (state, payload) => {
    state.defaultQuery = payload

    // Save empty query, as we don't want query to be saved anymore...
    saveLs(LS_KEY_QUERY, '')
  },
  'saveSearch': (state, payload) => {
    state.defaultFilters = payload.filters

    // Save only avdeling...
    const save = DEFAULT_FILTERS
    // save.avdeling = payload.filters.avdeling || []
    saveLs(LS_KEY_FILTERS, save)

    state.defaultQuery = payload.query

    // And save empty query, as we don't want query to be saved anymore...
    saveLs(LS_KEY_QUERY, '')
  },
  'resetSearch': (state, resetEverything) => {
    if (resetEverything) {
      state.defaultQuery = ''
      saveLs(LS_KEY_QUERY, '')
    }

    state.defaultFilters = DEFAULT_FILTERS
    saveLs(LS_KEY_FILTERS, DEFAULT_FILTERS)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customersearch.js